import { apiCall, dashboardApiServer } from '../../index'
import endpoints from './endpoints'

const apiDashboardServer = apiCall(dashboardApiServer)

interface EnterpriseRegistration {
  id: string
  orgnaizationId: string
  buildingId: string
  building: any
  organization: any
}

export const fetchEnterpriseRegistration = (enterpriseRegistrationId: string): Promise<EnterpriseRegistration> =>
  apiDashboardServer(endpoints.GET.EnterprisesRegistration.route(enterpriseRegistrationId), {
    method: 'get'
  })
